import { MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
// import useProposedChanges from '../../helpers/hooks/useProposedChanges'
import useProposedChanges from "../hooks/useProposedChanges";
import usePostAuthed from "../../../helpers/hooks/usePostAuthed";
// const isRevision = JSON.parse(localStorage.getItem('isRevision'))
import toastr from "toastr";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";

function ProposedChangesModal2({
  modal,
  toggleModal,
  feilds,
  getOptions,
  getCall,
}) {
  // states
  const [propsedFeilds, setProposedFeilds] = useState({});
  const isRevision = false;



  // hooks
  const [updated, updatedFeilds, setUpdatedFields] = useProposedChanges(feilds);
  console.log({ updatedFeilds, modal });
  const [call, data, error, loading] = usePostAuthed(
    "save_proposed_changes",
    "loan"
  );

  // functions
  const proposedChanges = () => {
    call({ loan_id: feilds.loan_id, proposed_changes: updatedFeilds }).then(
      () => getCall()
    );
    toggleModal();
  };

  useEffect(() => {
    if (updatedFeilds.length > 0) {
      setProposedFeilds(updatedFeilds);
    }
  }, [updatedFeilds]);

  useEffect(() => {
    if (data) {
      console.log({ data, error });
      // console.log(`ppppppppppp ${data}`)
      toastr.success("Proposed changes has been sent to the user");
    }
    if (error) {
      console.log({ data, error });
      toastr.error("Something happend wrong");
    }
  }, [data, error]);

  
  


  return (
    <>
      {updatedFeilds && (
        <Modal
          className="modal-dialog-centered"
          isOpen={modal}
          toggle={toggleModal}
          style={{ maxWidth: "800px" }}
        >
          <ModalHeader toggle={toggleModal}>
            {isRevision ? "Revision Changes" : "Propose Changes"}
          </ModalHeader>
          <ModalBody>
            <MDBCard>
              <MDBCardBody>
                <Accordion allowZeroExpanded>
                  <AccordionItem>
                    <AccordionItemHeading className="AccordionItem bg-gray-200 p-4 font-bold d-flex justify-content-center">
                      <AccordionItemButton
                        className="AccordionItemButton"
                        style={{ display: "contents" }}
                      >
                        {/* <span style={{ marginRight: "10px" }}>
                          ------------------------Urea And
                          Fertilizers---------------------
                        </span> */}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <hr style={{ width: "250px", borderColor: "blue" }} />{" "}
                          Urea And Fertilizers: <span>&#9650;</span>{" "}
                          <hr style={{ width: "250px", borderColor: "blue" }} />
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>Required Urea Quantity</MDBCardText>
                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );

                              updatedFeilds["required_urea_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.required_urea_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>

                        <hr />

                        <MDBCol sm="4">
                          <MDBCardText>Preferred Urea Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_urea_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_urea_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_urea_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(468).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>

                        <hr />

                        <MDBCol sm="4">
                          <MDBCardText>Required Dap Quantity</MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["required_dap_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.required_dap_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Dap Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_dap_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_dap_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_dap_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(457).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>Preferred Zinc Quantity</MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_zinc_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_zinc_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>Preferred Zinc Brand</MDBCardText>
                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_zinc_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_zinc_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_zinc_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(471).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Sop Quantity</MDBCardText>
                          {/* </MDBCol>
                  <MDBCol sm="7"> */}
                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_sop_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_sop_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>
                        {/* </MDBRow> */}
                        <hr />
                        {/* <MDBRow> */}
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Sop Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_sop_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_sop_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_sop_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(466).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        {/* </MDBRow> */}
                        <hr />
                        {/* <MDBRow> */}
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Np Quantity</MDBCardText>
                          {/* </MDBCol>
                  <MDBCol sm="7"> */}
                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_np_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_np_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>
                      </MDBRow>

                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Np Brand</MDBCardText>
                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_np_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_np_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_np_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(462).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Mop Quantity</MDBCardText>
                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_mop_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_mop_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Mop Brand</MDBCardText>
                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_mop_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_mop_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_mop_brand?.proposedValue
                                .name
                            }
                          >
                            {getOptions(460).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem>
                    <AccordionItemHeading className="AccordionItem bg-gray-200 p-4 font-bold d-flex justify-content-center">
                      <AccordionItemButton
                        className="AccordionItemButton"
                        style={{ display: "contents" }}
                      >
                        {/* <span style={{ marginRight: "10px" }}>
                          -------------------Pesticides And
                          Chemicals--------------------
                        </span> */}

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <hr style={{ width: "230px", borderColor: "blue" }} />{" "}
                          Pesticides And Chemicals: <span>&#9650;</span>{" "}
                          <hr style={{ width: "230px", borderColor: "blue" }} />
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>

                    <AccordionItemPanel>
                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>
                            Required Pesticides Quantity
                          </MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["required_pesticides_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            Text
                            className="text-muted"
                            value={
                              updatedFeilds?.required_pesticides_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>Preferred Pesticides Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_pesticides_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_pesticides_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_pesticides_brand
                                ?.proposedValue.name
                            }
                          >
                            {getOptions(464).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>
                            Preferred Weedicide Quantity
                          </MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_weedicide_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_weedicide_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow>
                        <MDBCol sm="4">
                          <MDBCardText>Preferred Weedicide Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_weedicide_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_weedicide_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_weedicide_brand
                                ?.proposedValue.name
                            }
                          >
                            {getOptions(469).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>
                            Preferred Fungicide Quantity
                          </MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["preferred_fungicide_quantity"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_fungicide_quantity
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>

                        <MDBCol sm="4">
                          <MDBCardText>Preferred Fungicide Brand</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              const name = e.target.value;
                              updatedFeilds["preferred_fungicide_brand"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_fungicide_brand"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_fungicide_brand
                                ?.proposedValue.name
                            }
                          >
                            {getOptions(458).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </AccordionItemPanel>
                  </AccordionItem>

                  <AccordionItem>
                    <AccordionItemHeading className="AccordionItem bg-gray-200 p-4 font-bold d-flex justify-content-center">
                      <AccordionItemButton
                        className="AccordionItemButton"
                        style={{ display: "contents" }}
                      >
                       

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <hr style={{ width: "260px", borderColor: "blue" }} />{" "}
                          Seeds Information: <span>&#9650;</span>{" "}
                          <hr style={{ width: "260px", borderColor: "blue" }} />
                        </div>
                      </AccordionItemButton>
                    </AccordionItemHeading>

                    <AccordionItemPanel>

                    
                      <MDBRow>
                        <MDBCol sm="6">
                          <MDBCardText>Required Seeds Quantity Kgs</MDBCardText>

                          <Input
                            readOnly={isRevision}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              const sanitizedValue = inputValue.replace(
                                /[^0-9.]/g,
                                ""
                              );
                              updatedFeilds["required_seeds_quantity_kgs"][
                                "proposedValue"
                              ] = sanitizedValue;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.required_seeds_quantity_kgs
                                ?.proposedValue
                            }
                          ></Input>
                        </MDBCol>

                        <MDBCol sm="6">
                          <MDBCardText>Preferred Seeds Company</MDBCardText>

                          <Input
                            type={!isRevision ? "select" : "text"}
                            readOnly={isRevision}
                            onChange={(e) => {
                              // updatedFeilds['preferred_seeds_company']['proposedValue'] = e.target.value
                              const name = e.target.value;
                              updatedFeilds["preferred_seeds_company"][
                                "proposedValue"
                              ]["name"] = name;
                              updatedFeilds["preferred_seeds_company"][
                                "proposedValue"
                              ][
                                "logo"
                              ] = `https://beythak-bucket.s3.ap-south-1.amazonaws.com/logos/${name
                                .toLowerCase()
                                .split(" ")
                                .join("")}.png`;
                              setUpdatedFields({ ...updatedFeilds });
                            }}
                            className="text-muted"
                            value={
                              updatedFeilds?.preferred_seeds_company
                                ?.proposedValue.name
                            }
                          >
                            {getOptions(465).map((x) => {
                              if (!isRevision)
                                return (
                                  <option key={x} value={x}>
                                    {x}
                                  </option>
                                );
                            })}
                          </Input>
                        </MDBCol>
                      </MDBRow>
                    </AccordionItemPanel>
                  </AccordionItem>
                </Accordion>
              </MDBCardBody>
            </MDBCard>
          </ModalBody>

          <ModalFooter className="d-block d-flex align-items-center justify-content-center">
            <div className="row">
              <div className="col">
                <Button
                  onClick={toggleModal}
                  style={{
                    width: "200px", // Set fixed width for consistent centering
                    borderRadius: "10px",
                    padding: "13px",
                    borderColor: "rgb(0,0,238)",
                    backgroundColor: "#fff",
                  }}
                >
                  <span style={{ color: "rgb(0,0,238)" }}>Cancel</span>
                </Button>
              </div>
              <div className="col">
                <Button
                  onClick={proposedChanges}
                  style={{
                    width: "203px",
                    borderRadius: "10px",
                    padding: "13px",
                    backgroundColor: "rgb(0,0,238)",
                    borderColor: "rgb(0,0,238)",
                  }}
                >
                  <span style={{ color: "#fff" }}>Save</span>
                </Button>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
}

export default ProposedChangesModal2;
